import React, { useEffect, useState } from 'react';
import FileUploadCard from '../common/FileUploadCard';
import apiClient from '../../context/apiClient';

const LeistungspaketeImport = () => {
    const [history, setHistory] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [usernameFilter, setUsernameFilter] = useState('');

    const fetchHistory = async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await apiClient.get('/api/employee/getStundenkontingenteLogInformation');
            setHistory(res.data);
        } catch (err) {
            setError(err.response?.data || err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchHistory();
    }, []);

    const filteredHistory = history.filter((entry) => {
        const createdAt = new Date(entry.createdAt);
        const fromDate = dateFrom ? new Date(dateFrom) : null;
        const toDate = dateTo ? new Date(dateTo) : null;

        const matchesDate =
            (!fromDate || createdAt >= fromDate) &&
            (!toDate || createdAt <= toDate);

        const matchesUsername = entry.username
            ?.toLowerCase()
            .includes(usernameFilter.toLowerCase());

        return matchesDate && matchesUsername;
    });

    return (
        <main className="flex-1 h-full w-full flex flex-col">
            <div className="flex flex-1 gap-6 overflow-hidden">
                <div className="w-full md:w-1/3 h-full">
                    <div className="bg-white shadow-md rounded-lg h-full p-6 flex flex-col justify-start">
                        <h3 className="text-lg font-semibold mb-4 text-center">Stundenkontingente hochladen</h3>
                        <p className="text-sm text-gray-600 mb-6 text-center">
                            Laden Sie eine Excel-Datei mit Stundenkontingente hoch. Nach dem Upload wird die History automatisch aktualisiert.
                        </p>
                        <FileUploadCard
                            uploadUrl="/api/employee/uploadStundenkontingente"
                            onSuccess={fetchHistory}
                        />
                    </div>
                </div>

                {/* History Section */}
                <div className="w-full md:w-2/3 h-full flex flex-col">
                    <div className="bg-white shadow-md rounded-lg h-full p-6 flex flex-col overflow-hidden">
                        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4 shrink-0">
                            <h2 className="text-xl font-semibold">Upload-History</h2>
                            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
                                <label className="text-sm text-gray-600">
                                    Zeitraum von:
                                    <input
                                        type="date"
                                        value={dateFrom}
                                        onChange={(e) => setDateFrom(e.target.value)}
                                        className="ml-2 border rounded px-2 py-1 text-sm"
                                    />
                                </label>
                                <label className="text-sm text-gray-600">
                                    bis:
                                    <input
                                        type="date"
                                        value={dateTo}
                                        onChange={(e) => setDateTo(e.target.value)}
                                        className="ml-2 border rounded px-2 py-1 text-sm"
                                    />
                                </label>
                                <input
                                    type="text"
                                    placeholder="Benutzer filtern"
                                    value={usernameFilter}
                                    onChange={(e) => setUsernameFilter(e.target.value)}
                                    className="border rounded px-2 py-1 text-sm"
                                />
                            </div>
                        </div>

                        <div className="overflow-y-auto flex-1 pr-2 space-y-4">
                            {loading ? (
                                <p className="text-gray-500">Lade Verlauf…</p>
                            ) : error ? (
                                <p className="text-red-600"><strong>Fehler:</strong> {String(error)}</p>
                            ) : filteredHistory.length === 0 ? (
                                <p className="text-gray-500">Keine Einträge vorhanden.</p>
                            ) : (
                                filteredHistory.slice().reverse().map((entry, index) => (
                                    <div key={index} className="border rounded p-4 bg-gray-50 shadow-sm">
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-4">
                                            <div>
                                                <strong>Dateiname:</strong><br />
                                                {entry.excelFileName || '-'}
                                            </div>
                                            <div>
                                                <strong>Benutzer:</strong><br />
                                                {entry.username || 'Unbekannt'}
                                            </div>
                                            <div>
                                                <strong>Erfasster Zeitraum:</strong><br />
                                                {entry.firstDate && entry.lastDate
                                                    ? `${new Date(entry.firstDate).toLocaleDateString('de-DE')} – ${new Date(entry.lastDate).toLocaleDateString('de-DE')}`
                                                    : '—'}
                                            </div>
                                            <div>
                                                <strong>Hochgeladen am:</strong><br />
                                                {entry.createdAt
                                                    ? new Date(entry.createdAt).toLocaleString('de-DE', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                    })
                                                    : '—'}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default LeistungspaketeImport;
